// extracted by mini-css-extract-plugin
module.exports = {"container":"SurveySelector_container__3Kwpi","description":"SurveySelector_description__26jhJ","warningText":"SurveySelector_warningText__1occe"};